module.exports = __webpack_public_path__ + "img/step2.f5eb7299.png";